import { useEffect, useRef, useState } from 'react';
import cls from './Game.module.scss';
import shipImage from '../../shared/assets/images/ship-2.svg';
import gameBg1 from '../../shared/assets/images/game-bg-2.webp';
import leftSrc from '../../shared/assets/images/left.svg';
import rightSrc from '../../shared/assets/images/right.svg';
import pauseSrc from '../../shared/assets/images/pause-button.svg';
import {
  Background,
  Obstacle,
  Ship2,
  Trail,
  isSegmentIntersectingPolygon,
  obstaclesList,
} from './game_assets';
import { setIsPause, userDead, userWon } from '../../shared/redux/game/slice';
import { useDispatch, useSelector } from 'react-redux';
import iceTextureSrc from '../../shared/assets/images/ice-texture.png';
import { Dead } from '../../shared/redux/game/types';
import { setPage } from '../../shared/redux/page/slice';
import { Pages } from '../../shared/redux/page/types';
import GiveUpSrc from '../../shared/assets/images/give-up-button.svg';
import ContinueSrc from '../../shared/assets/images/continue-button.svg';
import { RootState } from '../../shared/redux/store';
import { sounds } from '../../shared/ui/Sound/assets';
import { useSpring, animated } from '@react-spring/web';

// Загрузка изображений
const shipImg = new Image();
shipImg.src = shipImage;
shipImg.width = 20;
shipImg.height = 104;

const backgroundImage = new Image();
backgroundImage.src = gameBg1;
backgroundImage.width = 1920 * 0.65;
backgroundImage.height = 3240 * 0.65;

const textureIce = new Image();
textureIce.src = iceTextureSrc;
textureIce.width = 100;
textureIce.height = 47;

const bearImage = new Image();
bearImage.src = obstaclesList.bear.image;
bearImage.width = obstaclesList.bear.width;
bearImage.height = obstaclesList.bear.height;

const sealImage = new Image();
sealImage.src = obstaclesList.seal.image;
sealImage.width = obstaclesList.seal.width;
sealImage.height = obstaclesList.seal.height;

const whaleImage = new Image();
whaleImage.src = obstaclesList.whale.image;
whaleImage.width = obstaclesList.whale.width;
whaleImage.height = obstaclesList.whale.height;

const IceImage = new Image();
IceImage.src = obstaclesList.ice1.image;
IceImage.width = obstaclesList.ice1.width;
IceImage.height = obstaclesList.ice1.height;

const Ice2Image = new Image();
Ice2Image.src = obstaclesList.ice2.image;
Ice2Image.width = obstaclesList.ice2.width;
Ice2Image.height = obstaclesList.ice2.height;

const Ice3Image = new Image();
Ice3Image.src = obstaclesList.ice3.image;
Ice3Image.width = obstaclesList.ice3.width;
Ice3Image.height = obstaclesList.ice3.height;

//Тип для координат точек
export type positionType = {
  x: number;
  y: number;
};

//Точки координат препятствий
let randomPositionsArr: positionType[] = [];

//Функция для определения рандомных координат
const getRandomPosition = (isCenter: boolean = false) => {
  const minX = isCenter ? 7 : 0;
  const maxX = isCenter ? 9 : 16;
  const minY = 6;
  const maxY = window.innerHeight > 600 ? 25 : 23;
  let resultX: number;
  let resultY: number;
  let include = false;
  do {
    resultX = (Math.random() * (maxX - minX + 1) + minX) * 100;
    resultY = (Math.random() * (maxY - minY + 1) + minY) * 100;
    include = randomPositionsArr.some(
      (el) => Math.abs(el.x - resultX) < 250 && Math.abs(el.y - resultY) < 160,
    );
  } while (include);
  randomPositionsArr.push({
    x: resultX,
    y: resultY,
  });
  return {
    x: resultX,
    y: resultY,
  };
};

export const Level2 = () => {
  const windowApp = document.getElementById('app-window');
  const windowWidth = windowApp ? windowApp.offsetWidth : 375;
  const windowHeight = windowApp ? windowApp.offsetHeight : 667;
  const dispatch = useDispatch();
  const isSound = useSelector((state: RootState) => state.page.isSound);
  const isPausePressed = useSelector((state: RootState) => state.game.isPause);
  const [springPropsShip, setSpringPropsShip] = useSpring(() => ({
    transform: `translate3D(${windowWidth / 2 + 10}px, ${
      windowHeight - 200 - 52
    }px, 0px) rotate(0rad)`,
    config: { tension: 350, friction: 30 },
  }));

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const ctxRef = useRef<CanvasRenderingContext2D | null>(null);
  const playerRef = useRef<Ship2>(new Ship2(windowWidth / 2 + 20, windowHeight - 200, shipImg));
  const backgroundRef = useRef<Background>(
    new Background(
      -backgroundImage.width / 2 + windowWidth / 2,
      -backgroundImage.height + windowHeight,
      backgroundImage,
    ),
  );

  const trailRef = useRef<Trail>(
    new Trail(
      [
        { x: windowWidth / 2 + 10, y: windowHeight - 150 },
        { x: windowWidth / 2 + 30, y: windowHeight - 150 },
      ],
      textureIce,
    ),
  );

  const obstaclesRef = useRef<Obstacle[] | null>(null);
  const leftRef = useRef<HTMLImageElement | null>(null);
  const rightRef = useRef<HTMLImageElement | null>(null);
  const leftKeyPressed = useRef<boolean>(false);
  const rightKeyPressed = useRef<boolean>(false);
  const scrollOffsetRef = useRef<positionType>({
    x: 0,
    y: 0,
  });
  const scrollOffsetBgRef = useRef<positionType>({
    x: 0,
    y: 0,
  });
  const isPause = useRef(false);
  const isFirstLoaded = useRef<boolean>(true);

  const animationId = useRef<number | null>(null);

  const animate = () => {
    const ctx = ctxRef.current;
    animationId.current = requestAnimationFrame(animate);

    if (isPause.current) {
      cancelAnimationFrame(animationId.current);
    }

    if (obstaclesRef.current) {
      obstaclesRef.current.forEach((obstacle) => {
        if (
          animationId.current &&
          isSegmentIntersectingPolygon(
            playerRef.current.headPosition,
            playerRef.current.assPosition,
            obstacle.currentPoints,
          )
        ) {
          if (isSound) {
            sounds.collision.play();
          }
          cancelAnimationFrame(animationId.current);
          dispatch(userDead(obstacle.deadType));
          dispatch(setPage(Pages.PREFINAL));
        }
      });
    }
    setSpringPropsShip({
      transform: `translate3D(${playerRef.current.position.x - 10}px, ${
        playerRef.current.position.y - 52
      }px, 0px) rotate(${playerRef.current.angle}rad)`,
    });

    if (ctx) {
      ctx.fillStyle = '#e6fafe';
      ctx.fillRect(0, 0, windowWidth, windowHeight);

      backgroundRef.current.draw(ctx);
      if (obstaclesRef.current) {
        obstaclesRef.current.forEach((obstacle) => obstacle.update(ctx));
      }
      trailRef.current.update(ctx);
      playerRef.current.update(ctx);
    }

    if (
      leftKeyPressed.current &&
      scrollOffsetRef.current.x > -1000 &&
      playerRef.current.angle > -1.5
    ) {
      playerRef.current.angle -= 0.01;
    } else if (
      rightKeyPressed.current &&
      scrollOffsetRef.current.x < 1000 &&
      playerRef.current.angle < 1.5
    ) {
      playerRef.current.angle += 0.01;
    } else if (scrollOffsetRef.current.x < -1000) {
      playerRef.current.angle += 0.02;
    } else if (scrollOffsetRef.current.x > 1000) {
      playerRef.current.angle -= 0.02;
    }

    if (leftKeyPressed.current && playerRef.current.angle > -1.5) {
      if (scrollOffsetRef.current.x > -1000) {
        playerRef.current.angle -= 0.01;
      } else {
        playerRef.current.angle += 0.01;
      }
    } else if (rightKeyPressed.current && playerRef.current.angle < 1.5) {
      playerRef.current.angle += 0.01;
    }

    //change velocity
    if (
      playerRef.current.position.y > windowHeight / 2 &&
      playerRef.current.position.x < windowWidth / 2 + 60 &&
      playerRef.current.position.x > windowWidth / 2 - 40
    ) {
      playerRef.current.velocity.x = Math.sin(playerRef.current.angle) * 0.5;
      playerRef.current.velocity.y = -Math.cos(playerRef.current.angle) * 0.5;
      trailRef.current.coordinates.push(playerRef.current.sidesPoints[0]);
      trailRef.current.coordinates.unshift(playerRef.current.sidesPoints[1]);
      scrollOffsetRef.current.x += Math.sin(playerRef.current.angle);
      scrollOffsetRef.current.y += Math.cos(playerRef.current.angle);
    } else {
      scrollOffsetRef.current.x += Math.sin(playerRef.current.angle);
      scrollOffsetRef.current.y += Math.cos(playerRef.current.angle);
      playerRef.current.velocity.y = 0;
      playerRef.current.velocity.x = 0;
      trailRef.current.coordinates.push({
        x: playerRef.current.sidesPoints[0].x + scrollOffsetBgRef.current.x,
        y: playerRef.current.sidesPoints[0].y - scrollOffsetBgRef.current.y,
      });
      trailRef.current.coordinates.unshift({
        x: playerRef.current.sidesPoints[1].x + scrollOffsetBgRef.current.x,
        y: playerRef.current.sidesPoints[1].y - scrollOffsetBgRef.current.y,
      });

      if (
        scrollOffsetRef.current.y < 2800 ||
        scrollOffsetRef.current.x > 500 ||
        scrollOffsetRef.current.x < -500
      ) {
        backgroundRef.current.position.x += -Math.sin(playerRef.current.angle) * 0.5;
        backgroundRef.current.position.y += Math.cos(playerRef.current.angle) * 0.5;
        scrollOffsetBgRef.current.x += Math.sin(playerRef.current.angle) * 0.5;
        scrollOffsetBgRef.current.y += Math.cos(playerRef.current.angle) * 0.5;
        trailRef.current.position.x += -Math.sin(playerRef.current.angle) * 0.5;
        trailRef.current.position.y += Math.cos(playerRef.current.angle) * 0.5;
        if (obstaclesRef.current) {
          obstaclesRef.current.forEach((obstacle) => {
            obstacle.position.x += -Math.sin(playerRef.current.angle) * 0.5;
            obstacle.position.y += Math.cos(playerRef.current.angle) * 0.5;
          });
        }
      } else {
        cancelAnimationFrame(animationId.current);
        if (isSound) {
          sounds.ship2.play();
        }
        setTimeout(() => {
          dispatch(userWon());
        }, 2000);
      }
    }
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'ArrowLeft') {
      leftKeyPressed.current = true;
    } else if (e.key === 'ArrowRight') {
      rightKeyPressed.current = true;
    }
  };
  const handleKeyRelease = () => {
    leftKeyPressed.current = false;
    rightKeyPressed.current = false;
  };

  useEffect(() => {
    if (isPausePressed) {
      isPause.current = true;
    } else if (!isFirstLoaded.current) {
      isPause.current = false;
      animate();
      console.log('animate, isPausePressed: ', isPausePressed);
    }
  }, [isPausePressed]);

  useEffect(() => {
    randomPositionsArr = [];
    if (canvasRef.current && isFirstLoaded.current) {
      const canvas = canvasRef.current;
      // canvas.style.imageRendering = 'pixelated';
      const ctx = canvas ? canvas.getContext('2d') : null;
      ctxRef.current = ctx;
    }
    obstaclesRef.current = [
      new Obstacle(obstaclesList.bear.coordinates, bearImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.bear.coordinates, bearImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.bear.coordinates, bearImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.bear.coordinates, bearImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.bear.coordinates, bearImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.seal.coordinates, sealImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.seal.coordinates, sealImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.seal.coordinates, sealImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.seal.coordinates, sealImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.seal.coordinates, sealImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(
        obstaclesList.whale.coordinates,
        whaleImage,
        getRandomPosition(true),
        Dead.ANIMAL,
      ),
      new Obstacle(obstaclesList.whale.coordinates, whaleImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.whale.coordinates, whaleImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.whale.coordinates, whaleImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.whale.coordinates, whaleImage, getRandomPosition(), Dead.ANIMAL),
      new Obstacle(obstaclesList.ice1.coordinates, IceImage, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice1.coordinates, IceImage, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice1.coordinates, IceImage, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice1.coordinates, IceImage, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice1.coordinates, IceImage, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice2.coordinates, Ice2Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice2.coordinates, Ice2Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice2.coordinates, Ice2Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice2.coordinates, Ice2Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice2.coordinates, Ice2Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice3.coordinates, Ice3Image, getRandomPosition(true), Dead.ICE),
      new Obstacle(obstaclesList.ice3.coordinates, Ice3Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice3.coordinates, Ice3Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice3.coordinates, Ice3Image, getRandomPosition(), Dead.ICE),
      new Obstacle(obstaclesList.ice3.coordinates, Ice3Image, getRandomPosition(), Dead.ICE),
    ];
    leftRef.current?.addEventListener('mousedown', () => {
      leftKeyPressed.current = true;
    });
    leftRef.current?.addEventListener('mouseup', () => {
      leftKeyPressed.current = false;
    });
    rightRef.current?.addEventListener('mousedown', () => {
      rightKeyPressed.current = true;
    });
    rightRef.current?.addEventListener('mouseup', () => {
      rightKeyPressed.current = false;
    });

    window.addEventListener('keydown', handleKeyPress);
    window.addEventListener('keyup', handleKeyRelease);
    leftRef.current?.addEventListener('touchstart', function (event) {
      event.preventDefault();
      leftKeyPressed.current = true;
    });
    leftRef.current?.addEventListener('touchend', function (event) {
      event.preventDefault();
      leftKeyPressed.current = false;
    });
    rightRef.current?.addEventListener('touchstart', function (event) {
      event.preventDefault();
      rightKeyPressed.current = true;
    });
    rightRef.current?.addEventListener('touchend', function (event) {
      event.preventDefault();
      rightKeyPressed.current = false;
    });
    isFirstLoaded.current = false;
    // Начало анимации
    animate();
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      window.removeEventListener('keyup', handleKeyRelease);
    };
  }, []);

  return (
    <div className={`${cls.Game} page-container`}>
      <canvas ref={canvasRef} width={windowWidth} height={windowHeight} />
      <animated.img src={shipImage} className={cls.shipImage} style={{ ...springPropsShip }} />
      <div className={cls.buttons}>
        <img
          className={cls.button}
          alt="Left"
          src={leftSrc}
          ref={leftRef}
          onContextMenu={() => false}
        />
        <img
          className={cls.button}
          alt="Right"
          src={rightSrc}
          ref={rightRef}
          onContextMenu={() => false}
        />
      </div>

      {isPausePressed ? (
        <div className={cls.PausePageContainer}>
          <div className="text-container" style={{ top: '18%' }}>
            <h1 className="text-bg-h1">ПАУЗА</h1>
            <h1>ПАУЗА</h1>
          </div>
          <img
            alt="Give Up"
            src={GiveUpSrc}
            className={cls.GiveUp}
            onClick={() => {
              if (isSound) {
                sounds.btn.play();
              }
              dispatch(setPage(Pages.FINAL));
              dispatch(setIsPause(false));
              dispatch(userDead(Dead.NONE));
            }}
          />
          <img
            alt="Continue"
            src={ContinueSrc}
            className={cls.Continue}
            onClick={() => {
              if (isSound) {
                sounds.btn.play();
              }
              dispatch(setIsPause(false));
            }}
          />
        </div>
      ) : (
        <img
          className={cls.pauseImg}
          src={pauseSrc}
          alt="pause"
          onClick={() => {
            if (isSound) {
              sounds.btn.play();
            }
            dispatch(setIsPause(true));
          }}
        />
      )}
    </div>
  );
};
